const interactionHistoryItemSchema = {
  fields: [
    { name: "timestamp", type: "datetime" },
    {
      name: "actor",
      type: "select",
      options: ["CALLER", "AGENT", "SYSTEM"],
    },
    {
      name: "action_type",
      type: "select",
      options: [
        "DIALOG",
        "NON_DIALOG",
        "SILENCE",
        "STALL",
        "DISABLE_LINK",
        "ENABLE_LINK",
        "CONFIRMATION_START",
        "CONFIRMATION_END",
        "CHECK_IN_DIALOG",
        "DTMF",
      ],
    },
    { name: "action", type: "text" },
    { name: "hide", type: "checkbox" },
  ],
};

const botInfoSchema = {
  fields: [
    { name: "name", type: "text" },
    { name: "company", type: "text" },
    { name: "title", type: "text" },
    { name: "carefulness", type: "number" },
    { name: "formality", type: "number" },
    { name: "chattiness", type: "number" },
    { name: "empathy", type: "number" },
    { name: "articulation", type: "number" },
    { name: "timezone", type: "text" },
  ],
};

export const taskSchemas = {
  LINK_PICKING: {
    fields: [
      {
        name: "interaction_history",
        type: "list",
        itemType: "object",
        schema: interactionHistoryItemSchema,
      },
      { name: "created_at", type: "datetime" },
      { name: "playbook_suggestion", type: "text" },
      { name: "choices", type: "list", itemType: "text" },
    ],
  },
  DIALOG_RESPONSE: {
    fields: [
      {
        name: "interaction_history",
        type: "list",
        itemType: "object",
        schema: interactionHistoryItemSchema,
      },
      { name: "created_at", type: "datetime" },
      { name: "playbook_suggestion", type: "text" },
      {
        name: "executive_suggestion",
        type: "select",
        options: [
          "WAIT",
          "REPEAT",
          "ARE_YOU_HUMAN",
          "NO_DIALOG",
          "FILLER",
          "HANG_UP",
          "ESCALATE",
        ],
      },
      { name: "choices", type: "list", itemType: "text" },
      { name: "bot_info", type: "object", schema: botInfoSchema },
      { name: "kb_suggestions", type: "list", itemType: "text" },
    ],
  },
};
